<script lang='ts'>
import { defineComponent } from '@vue/composition-api';

interface IProps {
    value: boolean;
    disabled: boolean;
}

const AppCheckbox = defineComponent({
    name: 'AppCheckbox',
    props: {
        value: Boolean,
        disabled: Boolean,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const onChange = (newValue: boolean) => {
            ctx.emit('input', newValue);
        };

        return {
            onChange,
        };
    },
});

export default AppCheckbox;
</script>

<template>
  <v-btn
    v-if="value"
    rounded
    icon
    small
    class="primary white--text"
    :style="{'pointer-events': disabled ? 'none' : 'auto'}"
    :disabled="disabled"
    @click="onChange(false)"
  >
    <v-icon color="white">
      $check-solid
    </v-icon>
  </v-btn>
          
  <v-btn
    v-else
    outlined
    icon
    small
    :disabled="disabled"
    color="blueGrey60Light"
    :style="{'pointer-events': disabled ? 'none' : 'auto'}"
    @click="onChange(true)"
  />
</template>

<style lang='scss' scoped></style>